// extracted by mini-css-extract-plugin
export default {"badge":"SessionIdleBadge_badge__yhkFq","label":"SessionIdleBadge_label__uh+hf","time":"SessionIdleBadge_time__S7AwK","warn":"SessionIdleBadge_warn__IYJRF"};